import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  output,
  Renderer2,
} from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import {
  DASH_SECTION_KEYS,
  DASH_SECTION_LABELS,
  DashboardConfig,
  DashboardSectionKey,
} from '../../models/dashboard-config.model';

@Component({
  selector: 'app-dashboard-config-panel',
  imports: [TranslatePipe, MatIcon, A11yModule],
  templateUrl: './dashboard-config-panel.component.html',
  styleUrl: './dashboard-config-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardConfigPanelComponent {
  config = input.required<DashboardConfig>();
  username = input<string>('');

  sectionToggle = output<DashboardSectionKey>();
  resetToDefault = output<void>();
  closePanel = output<void>();

  protected readonly keys = DASH_SECTION_KEYS;
  protected readonly labels = DASH_SECTION_LABELS;

  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() => {
      const stopClick = this.renderer.listen('document', 'click', (event: Event) => {
        if (!event.composedPath().includes(this.host.nativeElement)) {
          this.closePanel.emit();
        }
      });
      const stopKey = this.renderer.listen('document', 'keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape') this.closePanel.emit();
      });
      this.destroyRef.onDestroy(() => {
        stopClick();
        stopKey();
      });
    });
  }

  protected isOn(key: DashboardSectionKey): boolean {
    return this.config().sections[key];
  }

  protected onToggle(key: DashboardSectionKey): void {
    this.sectionToggle.emit(key);
  }

  protected onReset(): void {
    if (this.config().isDefault) return;
    this.resetToDefault.emit();
  }

  protected onClose(): void {
    this.closePanel.emit();
  }
}
